import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { CampaignCashRewardPage } from "./campaign-cash-reward";

@NgModule({
  declarations: [CampaignCashRewardPage],
  imports: [IonicPageModule.forChild(CampaignCashRewardPage)],
})
export class CampaignCashRewardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/campaign-cash-reward/campaign-cash-reward.module.ts